import { render, staticRenderFns } from "./ListClaim.vue?vue&type=template&id=106b942f&scoped=true&"
import script from "./ListClaim.vue?vue&type=script&lang=js&"
export * from "./ListClaim.vue?vue&type=script&lang=js&"
import style0 from "./ListClaim.vue?vue&type=style&index=0&id=106b942f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106b942f",
  null
  
)

export default component.exports